import { useForm } from 'react-hook-form';
import { MdErrorOutline } from 'react-icons/md';
import { useDispatch } from 'react-redux';
import { useTheme } from 'styled-components';
import Button from '../../../../components/Button/Button';
import Modal from '../../../../components/Modal/Modal';
import TextField from '../../../../components/TextField';
import { denyUserFetchAction } from '../../../../store/fetchActions/denyUserActions';
import { ButtonContainer, SmallerModal } from '../../styles/GerenciarClientes.styles';

const DeniedClient = ({ open, close, info }) => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const { control, handleSubmit } = useForm({});

  const submitDenyForm = (data) => {
    const param = { CPFUSUARIO: info?.CPFCNPJ, ERRO_STATUS: data.justificativa, ID_PRODUTO_DIGITAL: info?.ID_PRODUTO_DIGITAL };
    dispatch(denyUserFetchAction(param, close));
  };

  return (
    <Modal open={open} close={close}>
      <SmallerModal>
        <MdErrorOutline color={theme.colors.nutBrown} size={'6.944vw'} />
        <h3>Negar Cliente</h3>
        <h5>Tem certeza que deseja negar o cliente?</h5>
        <h4>Justificativa</h4>
        <form onSubmit={handleSubmit(submitDenyForm)}>
          <TextField
            variant={'outlined'}
            name={'justificativa'}
            width={'28.342vw'}
            multiline={true}
            minRows={3}
            required={true}
            control={control}
            inputProps={{ maxLength: 100 }}
          />
          <ButtonContainer>
            <Button
              backgroundcolor={theme.colors.buttonBack}
              width={'13.792vw'}
              height={'3.125vw'}
              hoverbgcolor={theme.colors.buttonBackHover}
              hovercolor={theme.colors.buttonBackHoverText}
              mycolor={theme.colors.buttonBackText}
              onClick={() => {
                closeModalDeny();
              }}
            >
              <span>Voltar</span>
            </Button>
            <Button
              backgroundcolor={theme.colors.buttonNegaded}
              width={'13.792vw'}
              height={'3.125vw'}
              hoverbgcolor={theme.colors.buttonNegadedHover}
              hovercolor={theme.colors.buttonNegadedHoverText}
              mycolor={theme.colors.buttonNegadedText}
              type="submit"
            >
              <span>Negar</span>
            </Button>
          </ButtonContainer>
        </form>
      </SmallerModal>
    </Modal>
  );
};

export default DeniedClient;
